/* eslint-disable react/react-in-jsx-scope */

export default function CommonLog({
    date, name, time, action, componentName,
}) {
    return (
        <div className="pt-1">
            <p className="text-xs2 font-semibold text-[#808285]">
                {date}
                {' '}
                |
                {time}
                {' '}

            </p>
            <p className="pt-1 text-xs6 font-normal text-[#090406]">
                <span className="font-semibold">{name}</span>
                {' '}
                {action}
                {' '}
                the
                {' '}
                {componentName}
                .
            </p>
        </div>
    );
}
